declare global {
    var PitchPrintClient: new (config: NPitchPrint.IClientConfig) => NPitchPrint.IClient;
}

declare module '@tomandco/nexus-api-types' {
    namespace Nexus {
        namespace Lib {
            namespace General {
                interface AppData {
                    pitchPrint?: NPitchPrint.IConfig;
                }
            }
        }
    }
}

export namespace NPitchPrint {
    export enum EAssets {
        jquery = 'https://code.jquery.com/jquery-3.1.1.min.js',
        client = 'https://pitchprint.io/rsc/js/client.js'
    }

    export interface IClientConfig {
        apiKey: string;
        designId?: string;
        custom?: boolean;
        uploadUrl?: string;
        userId?: string;
        langCode?: string;
        enableUpload?: 0 | 1;
        mode?: 'edit' | 'new';
        createButtons?: boolean;
        projectId?: string;
        pluginRoot?: string;
        client?: string;
        product?: {
            id: string;
            name: string;
        };
        previews?: string;
    }

    export interface IConfig {
        apiKey: string[];
    }

    export interface IClient {
        on(event: TClientOnEvent, callback: (data: any) => void): void;
        fire(event: TClientFireEvent, data?: any): void;
        showApp(): void;
        _triggerPdfDownload(): void;
    }

    export type TClientOnEvent =
        | 'app-validated'
        | 'project-saved'
        | 'lib-ready'
        | 'before-show'
        | 'editor-shown'
        | 'design-loaded'
        | 'after-close-app'
        | 'app-client-pageCount'
        | 'app-client-templateChange'
        | 'app-client-canvasResized'
        | 'page-created'
        | 'page-select-end'
        | 'before-save'
        | 'module-initialized';

    export type TClientFireEvent =
        | 'show-preview'
        | 'hide-preview'
        | 'delete-items'
        | 'copy-items'
        | 'cut-items'
        | 'paste-items'
        | 'discard-selection'
        | 'undo'
        | 'redo'
        | 'show-app'
        | 'load-design'
        | 'load-design-by-id'
        | 'show-preset-form'
        | 'close-app'
        | 'show-welcome'
        | 'select-page'
        | 'swap-page-dimension'
        | 'zoom-page'
        | 'fit-page'
        | 'load-image'
        | 'new-text'
        | 'show-flash'
        | 'hide-flash'
        | 'blank-page'
        | 'resize-page'
        | 'delete-page'
        | 'update-bleed';

    export interface IProjectSavedEvent {
        type: 'project-saved';
        data: IProject;
    }

    export interface IProject {
        autoSaved?: boolean;
        distiller?: string;
        isvx?: boolean;
        meta?: { [key: string]: any };
        numPages?: number;
        previews?: string[];
        projectId?: string;
        saveForLater?: boolean;
        title?: string;
        userId?: string;
        source?: IProjectSource;
    }

    export interface IProjectSource {
        productId: string;
        projectId: string;
    }

    export type TIStorageData = { [key: string]: IProject };
}
